
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fraud",
      function () {
        return require("private-next-pages/fraud/index.tsx");
      }
    ]);
  